import { render } from "./NumberingSettings.vue?vue&type=template&id=afcc5888"
import script from "./NumberingSettings.vue?vue&type=script&lang=js"
export * from "./NumberingSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__